import React from 'react';
import { connect } from 'react-redux';
import { getReferralListing } from 'hb-redux-store/feature/accounts/accounts.action';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import Icon from '../../components/mweb/Icon/Icon';

const ReferralHistory = props => {
  const { referralLoading, referralDetails, getReferralListing } = props;
  // const referralDetails = {
  //   "totalEarned": 300.0,
  //   "totalPending": 150.0,
  //   "totalEarnedInvitations": 2,
  //   "totalPendingInvitations": 3,
  //   "refreeList": [
  //     {
  //       "amount": 50.0,
  //       "mobileNumber": "9405582256",
  //       "date": "29-05-2020",
  //       "pending": true
  //     },
  //     {
  //       "amount": 50.0,
  //       "mobileNumber": "9987049521",
  //       "date": "29-05-2020",
  //       "pending": true
  //     },
  //     {
  //       "amount": 50.0,
  //       "mobileNumber": "9987049523",
  //       "date": "29-05-2020",
  //       "pending": true
  //     },
  //     {
  //       "amount": 150.0,
  //       "mobileNumber": "9405582256",
  //       "date": "29-05-2020",
  //       "pending": false
  //     },
  //     {
  //       "amount": 150.0,
  //       "mobileNumber": "9987049521",
  //       "date": "29-05-2020",
  //       "pending": false
  //     }
  //   ]
  // }
  React.useEffect(() => {
    getReferralListing();
  }, []);
  return (
    <div className="referral-history">
      <SecondaryNav
        source="accounts"
        showCart={false}
        showSearch={false}
        title="Referral History"
        capitalize
      />
      {referralLoading && <Loader />}
      {!referralLoading && (
        <div>
          <div className="referral-history--summary--blocks balance std-margin-lr">
            <Icon
              class="icon-order-box-coins-no-shadow balance-icon"
              size={40}
            />
            <div>
              <div className="referral-history--balance--amount">
                Referral Balance &#8377;{referralDetails?.currentBalance || 0}
              </div>
              <div className="referral-history--balance--invitations">
                This amount can be used for the next order
              </div>
            </div>
          </div>
          <div className="referral-history--summary">
            <div className="referral-history--summary--blocks earned">
              <Icon class="icon-referral-earned" size={40} />
              <div className="referral-history--summary--amount">
                &#8377;{referralDetails?.totalEarned || 0} earned
              </div>
              <div className="referral-history--summary--invitations">
                {referralDetails?.totalEarnedInvitations > 1
                  ? `${referralDetails?.totalEarnedInvitations} successful invitations`
                  : `${referralDetails?.totalEarnedInvitations ||
                      0} successful invitation`}
              </div>
            </div>
            <div className="referral-history--summary--dummy" />
            <div className="referral-history--summary--blocks pending">
              <Icon class="icon-referral-pending" size={40} />
              <div className="referral-history--summary--amount">
                &#8377;{referralDetails?.totalPending || 0} can be earned
              </div>
              <div className="referral-history--summary--invitations">
                {referralDetails?.totalPendingInvitations > 1
                  ? `${referralDetails?.totalPendingInvitations} pending invitations`
                  : `${referralDetails?.totalPendingInvitations ||
                      0} pending invitation`}
              </div>
            </div>
          </div>
          {/*{referralDetails?.totalEarnedInvitations === 0 &&*/}
          {/*  referralDetails?.totalPendingInvitations === 0 && (*/}
          <div className="referral-history--description">
            Spread the word around and introduce more friends to VegXL! Keep
            inviting and earning more credits.
          </div>
          {/*)}*/}
          {referralDetails?.refreeList?.length > 0 && (
            <div className="referral-history--history">
              {referralDetails?.refreeList.map((referral, index) => {
                const { pending } = referral;
                return (
                  <div key={index} className="referral-transaction">
                    <Icon
                      class={`icon-referral-${
                        pending ? 'pending' : 'earned'
                      } flex-shrink-0`}
                      size={30}
                    />
                    <div
                      className={`referral-transaction--details ${
                        index === referralDetails.refreeList.length - 1
                          ? 'last'
                          : ''
                      }`}
                    >
                      <div className="referral-transaction--details--amount">
                        <span className="bold">&#8377;{referral.amount}</span>{' '}
                        {pending ? 'can be earned' : 'earned successfully'}
                      </div>
                      <div className="referral-transaction--details--no">
                        <div>
                          {pending ? 'Invitation pending +91 ' : 'Invited +91 '}
                          {referral.mobileNumber}
                        </div>
                        <div>{referral.date}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ accountsReducer }) => ({
  referralDetails: accountsReducer.referralDetails,
  referralLoading: accountsReducer.referralLoading,
});

const mapDispatchToProps = {
  getReferralListing,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralHistory);
